import { render, staticRenderFns } from "./areaCharts.vue?vue&type=template&id=f4508a7c&scoped=true&"
import script from "./areaCharts.vue?vue&type=script&lang=js&"
export * from "./areaCharts.vue?vue&type=script&lang=js&"
import style0 from "./areaCharts.vue?vue&type=style&index=0&id=f4508a7c&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4508a7c",
  null
  
)

component.options.__file = "areaCharts.vue"
export default component.exports